const initialeState = {
    counter : 0,
    displayModal: false,
    formuleSelect: 1,
    types: [],
    structureInfo : {
        genre_id: 0,
        type_id: 0,
        processState: 1
    }
}


const SubscribtionReducer = (state=initialeState, action) => {
    switch (action.type) {
        case  'TOGGLE_SUBSCRIB_MODAL':
            return {
                ...state,
                displayModal : !state.displayModal
            }
        case  'UPDATE_PROCESS-STATE':
            return {
                ...state,
                processState : action.data.value
            }
        case  'UPDATE_FORMULE_SELECT':
            return {
                ...state,
                formuleSelect : action.data.value
            }
        case  'UPDATE_STRUCTURE_INFO':
            return {
                ...state,
                structureInfo : {
                    ...state.structureInfo,
                    ...action.data
                }
            }
        case  'UPDATE_TYPES':
            return {
                ...state,
                types : action.data.types
            }

        default:
            return state
    }
}

export default SubscribtionReducer
